import { useFrame } from '@react-three/fiber'
import React, { useState, useEffect, useRef } from 'react'
import { Box3, BoxHelper, Vector3 } from 'three'
import { gsap } from 'gsap'

export function SceneZone(props)
{
  const sceneData = props.object

  const zoneRef = useRef()

  const getCallbacks = element =>
  {
    const callbacks = {}

    const mainObj = element.object
    const type = mainObj.userData?.type
    const data = mainObj.userData?.interactableData

    if (mainObj.userData?.type !== 'interactable')
    {
      return
    }

    const originalScale = element.scale || new Vector3(1, 1, 1)

    callbacks.onClick = event =>
    {
      // console.log('SceneZone: onClick fired', element.object.name)
      props.interactionManager.handleInteraction(event, element)
    }

    if (
      (mainObj.userData?.OnPointerEnterAnimations !== undefined && mainObj.userData?.OnPointerEnterAnimations !== null && mainObj.userData?.OnPointerEnterAnimations.length > 0) ||
      mainObj.userData.mediaTrigger === 'OnPointerEnter'
    )
    {
      callbacks.onPointerEnter = event =>
      {
        props.interactionManager.handlePointerEnter(event, element)
      }
    }

    if (
      (mainObj.userData?.OnPointerExitAnimations !== undefined && mainObj.userData?.OnPointerExitAnimations !== null && mainObj.userData?.OnPointerExitAnimations.length > 0) ||
      mainObj.userData.mediaTrigger === 'OnPointerExit'
    )
    {
      callbacks.onPointerLeave = event =>
      {
        props.interactionManager.handlePointerExit(event, element)
        document.body.style.cursor = 'auto'
      }
    }

    return callbacks
  }

  return (
    <>
      <group ref={zoneRef}>
        {sceneData.objects.interactables.map((element, key) => (
          <InteractableObject key={key} element={element} getCallbacks={getCallbacks} />
        ))}
      </group>
    </>
  )
}

function InteractableObject({ element, getCallbacks })
{
  React.useLayoutEffect(() =>
  {
    // detailed-debug: Validate object identity
    // console.log(`[SceneZone] Mounting "${element.object.name}" (UUID: ${element.object.uuid})`)
    // console.log(`[SceneZone]   - Parent: "${element.object.parent?.name}" (UUID: ${element.object.parent?.uuid})`)

    // Apply initial transform once to handle reparenting/world-positioning
    // We do this here instead of props to avoid React overwriting animation updates on re-renders
    if (element.worldPosition) element.object.position.copy(element.worldPosition)
    if (element.rotation) element.object.rotation.copy(element.rotation)
    if (element.scale) element.object.scale.copy(element.scale)
  }, [ element ])

  return (
    <group {...getCallbacks(element)}>
      <primitive object={element.object} />
    </group>
  )
}
